<template>
  <div class="projects-page">
    <h2 class="page-title">项目展示</h2>
    <p class="page-desc">一些我参与或独立开发的项目</p>
    <div v-loading="loading" class="projects-grid">
      <div class="project-card" v-for="proj in projects" :key="proj.id">
        <div class="card-header">
          <span class="repo-icon">📖</span>
          <a :href="proj.url" target="_blank" class="repo-name">{{ proj.name }}</a>
          <span :class="'repo-visibility'" :style="{ color: proj.is_private ? '#e0e6ed' : '#c47a3a', borderColor: proj.is_private ? 'rgba(224,230,237,0.3)' : 'rgba(196,122,58,0.3)' }" class="repo-visibility-badge">{{ proj.is_private ? 'Private' : 'Public' }}</span>
        </div>
        <p class="repo-desc">{{ proj.desc }}</p>
        <div class="repo-meta">
          <span class="repo-lang" v-if="proj.lang">
            <span class="lang-dot" :style="{ background: proj.lang_color }"></span>
            {{ proj.lang }}
          </span>
          <span class="repo-stars" v-if="proj.stars >= 0">
            <i class="el-icon-star-off"></i> {{ proj.stars }}
          </span>
          <span class="repo-forks" v-if="proj.forks >= 0">
            <i class="el-icon-share"></i> {{ proj.forks }}
          </span>
          <span class="repo-updated">更新于 {{ proj.updated_date }}</span>
        </div>
        <div class="repo-tags">
          <span class="repo-tag" v-for="t in proj.tags" :key="t">{{ t }}</span>
        </div>
      </div>
    </div>
    <div v-if="!loading && projects.length === 0" class="no-projects">
      暂无项目，请在后台添加
    </div>
  </div>
</template>

<script>
import { frontApi } from '../../utils/api'

export default {
  name: 'Projects',
  data() {
    return {
      projects: [],
      loading: false
    }
  },
  created() {
    this.loadProjects()
  },
  methods: {
    async loadProjects() {
      this.loading = true
      try {
        const res = await frontApi.getProjects()
        this.projects = res.projects || []
      } catch (e) {
        console.error(e)
        this.$message.error('加载项目失败')
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
.projects-page {
  padding-bottom: 40px;
}
.page-title {
  font-size: 26px;
  font-weight: 700;
  color: var(--blog-text);
  margin-bottom: 6px;
}
.page-desc {
  color: var(--blog-text-3);
  font-size: 14px;
  margin-bottom: 28px;
}
.projects-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}
.project-card {
  background: var(--blog-card-bg);
  border:1px solid var(--blog-card-border);
  border-radius: 8px;
  padding: 20px;
  transition: all 0.3s;
}
.project-card:hover {
  border-color: var(--blog-accent);
  box-shadow: 0 4px 20px rgba(196, 122, 58, 0.08);
  transform: translateY(-2px);
}
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 8px;
}
.repo-icon {
  font-size: 18px;
}
.repo-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--blog-accent) !important;
  text-decoration: none !important;
  flex:1;
}
.repo-name:hover {
  text-decoration: underline !important;
  text-shadow: 0 0 8px rgba(196, 122, 58, 0.3);
}
.repo-visibility-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid;
  font-weight: 500;
}
.repo-desc {
  font-size: 13px;
  color: var(--blog-text-3);
  line-height: 1.7;
  margin-bottom: 14px;
  min-height: 42px;
}
.repo-meta {
  display: flex;
  align-items: center;
  gap: 14px;
  font-size: 12px;
  color: var(--blog-text-3);
  margin-bottom: 12px;
  flex-wrap: wrap;
}
.repo-lang {
  display: flex;
  align-items: center;
  gap: 4px;
}
.lang-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
}
.repo-updated {
  margin-left: auto;
}
.repo-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.repo-tag {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  background: rgba(196, 122, 58, 0.08);
  color: var(--blog-accent);
  border:1px solid rgba(196, 122, 58, 0.15);
}
.no-projects {
  text-align: center;
  color: var(--blog-text-3);
  padding: 40px 0;
  font-size: 14px;
}
@media (max-width: 768px) {
  .projects-grid {
    grid-template-columns: 1fr;
  }
}
</style>
